import Button from '../../../components/base/Button';

export default function HeroSection() {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="min-h-screen flex items-center justify-center bg-white pt-20">
      <div className="max-w-7xl mx-auto px-6 py-20">
        <div className="text-center max-w-6xl mx-auto">
          <h1 className="text-6xl sm:text-8xl md:text-9xl lg:text-[8rem] xl:text-[12rem] font-bold text-gray-900 leading-none mb-8 sm:mb-12">
            Travel Without
            <br />
            <span className="text-[#2C2CE8]">
              What-Ifs
            </span>
          </h1>

          <p className="text-lg sm:text-xl md:text-2xl text-gray-600 max-w-3xl mx-auto mb-10 sm:mb-14 leading-relaxed">
            Our technology analyzes hundreds of thousands of signals to detect flight disruptions, giving you the advantage to move first, options that work for you, and the confidence to travel smoothly.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 sm:gap-6 md:gap-8 justify-center">
            <Button 
              size="lg"
              onClick={() => scrollToSection('waitlist')}
              className="px-8 sm:px-12 md:px-16 py-4 sm:py-5 md:py-6 text-lg sm:text-xl md:text-2xl font-semibold whitespace-nowrap cursor-pointer"
            >
              Get Early Access
            </Button>
            <Button 
              variant="outline"
              size="lg"
              onClick={() => scrollToSection('features')}
              className="px-8 sm:px-12 md:px-16 py-4 sm:py-5 md:py-6 text-lg sm:text-xl md:text-2xl font-semibold whitespace-nowrap cursor-pointer"
            >
              View Features
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}
